import { StudentProfile } from "./types";

export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

const isNegative = (value: number): boolean => value < 0;

export function validateStudentProfile(profile: StudentProfile): ValidationResult {
  const errors: string[] = [];

  if (profile.age <= 0) {
    errors.push("age must be greater than 0");
  }

  if (profile.yearsOutOfHighSchool < 0) {
    errors.push("years out of high school cannot be negative");
  }

  if (!profile.study.school.trim()) {
    errors.push("school is required");
  }

  if (!profile.study.programName.trim()) {
    errors.push("program name is required");
  }

  if (profile.study.studyWeeks <= 0) {
    errors.push("study weeks must be greater than 0");
  }

  if (profile.study.numberOfTerms <= 0) {
    errors.push("number of terms must be greater than 0");
  }

  if (profile.study.tuition <= 0) {
    errors.push("tuition must be greater than 0");
  }

  if (
    [
      profile.study.booksSupplies,
      profile.financial.studentIncome,
      profile.financial.studentAssets,
      profile.financial.scholarshipsAwards,
      profile.financial.governmentIncome,
      profile.dependants.childCareCosts,
      profile.dependants.age0To11,
      profile.dependants.age12PlusNoDisability,
      profile.dependants.age12PlusWithDisability,
    ].some(isNegative)
  ) {
    errors.push("money values and dependant counts cannot be negative");
  }

  if (
    profile.study.actualMonthlyRent !== undefined &&
    profile.study.actualMonthlyRent < 0
  ) {
    errors.push("actual monthly rent cannot be negative");
  }

  const spouseRequired =
    profile.status === "married" || profile.status === "common_law";

  if (spouseRequired && profile.spouse.spouseIncome === undefined) {
    errors.push("spouse income is required for married/common law students");
  }

  const parentInfoLikelyRequired =
    profile.yearsOutOfHighSchool < 6 &&
    !profile.worked24MonthsInARow &&
    profile.status === "single";

  if (
    parentInfoLikelyRequired &&
    profile.parents.parent1Income === undefined &&
    profile.parents.parent2Income === undefined
  ) {
    errors.push("at least one parent income is required for dependent students");
  }

  if (!profile.ontarioResident) {
    errors.push("this calculator currently supports ontario residents only");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}